import { PublishStatusEnum } from '../api/utils';

export class GitHubItem {
  constructor(
    name,
    path,
    type,
    stagingstatus = PublishStatusEnum.UNKNOWN,
    productionstatus = PublishStatusEnum.UNKNOWN,
    stagingindex = PublishStatusEnum.UNKNOWN,
    productionindex = PublishStatusEnum.UNKNOWN
  ) {
    this.name = name;
    this.path = path;
    this.id = path;
    this.type = type;
    this.stagingpermission = [];
    this.productionpermission = [];
    this.stagingstatus = stagingstatus;
    this.productionstatus = productionstatus;
    this.stagingindex = stagingindex;
    this.productionindex = productionindex;
  }
}
